import {
  GET_ORGANIZATIONS,
  CREATE_ORGANIZATIONS,
  DELETE_ORGANIZATIONS,
  UPDATE_ORGANIZATIONS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  organizations: [],
  error: {},
  success: "",
};

const Organizations = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ORGANIZATIONS:
          return {
            ...state,
            organizations: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_ORGANIZATIONS:
          return {
            ...state,
            success: "Sucessfully created organizations",
            error: {},
          };
        case UPDATE_ORGANIZATIONS:
          return {
            ...state,
            success: "Sucessfully updated organizations",
            error: {},
          };
        case DELETE_ORGANIZATIONS:
          return {
            ...state,
            success: "Sucessfully delete organizations",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_ORGANIZATIONS:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        case CREATE_ORGANIZATIONS:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        case UPDATE_ORGANIZATIONS:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        case DELETE_ORGANIZATIONS:
          return {
            ...state,
            success: "",
            error: action.payload.response.data.message,
          };
        default:
          return { ...state };
      }
    case GET_ORGANIZATIONS: {
      return {
        ...state,
      };
    }
    case CREATE_ORGANIZATIONS: {
      return {
        ...state,
      };
    }
    case UPDATE_ORGANIZATIONS: {
      return {
        ...state,
      };
    }
    case DELETE_ORGANIZATIONS: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Organizations;
